import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../Hooks/useAuth";
import NewBoatPopupMessage from "../../Components/BoatRegistration/NewBoatPopupMessage";

const BoatRegiOption = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMsg, setDialogMsg] = useState("");

  useEffect(() => {
    let dialogMessage = null;

    if (auth?.isAblePrintOrRegister !== true) {
      dialogMessage =
        "You have recently made changes to personal details. Some functions (Printing Certificates, New Vessel Registrations) are unavailable until MAST have confirmed these changes.";
    }

    if (auth?.isPnaIdVerified !== true) {
      dialogMessage =
        "Your account with MAST is not yet Verified. You will be unable to complete any transactions involving boat registration until you provide identity information to Service Tasmania or MAST.";
    }

    if (dialogMessage) {
      setDialogMsg(dialogMessage);
      setOpenDialog(true);
    } else {
      setIsOpen(true);
    }
  }, []);

  const handleSetIsOpen = (val) => {
    setIsOpen(val);
    if (!val) navigate("/", { replace: true });
  };

  const handleSetOpenDialog = (val) => {
    setOpenDialog(val);
    if (!val) navigate("/", { replace: true });
  };

  return (
    <NewBoatPopupMessage
      isOpen={isOpen}
      setIsOpen={handleSetIsOpen}
      openDialog={openDialog}
      setOpenDialog={handleSetOpenDialog}
      dialogMsg={dialogMsg}
    />
  );
};

export default BoatRegiOption;
